export default {
  "app": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Портфолио Лихачева Мария"])}
  },
  "nav": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["главная"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обо мне"])},
    "project": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мои проекты"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Связаться со мной"])}
  },
  "home": {
    "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Привет!"])},
    "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Я Маша, и я web-разработчик"])},
    "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Смотреть проекты"])}
  },
  "about": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обо мне"])},
    "text-one": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["На сегодняшний день Интернет – самый востребованный способ раскрутки и продвижения компании. Сайт компании – это презентация ее в сети для клиентов, визитная карточка, которую невозможно потерять."])},
    "text-two": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создаю сайты малого объема, состоящие из одной или нескольких страниц, либо сайт-каталог с информацией о товарах компании, с адаптацией под мобильные устройства, размещаю в сети интернет и настраиваю в поиске Яндекс и Google. Всегда на связи, ориентирована на результат, прорабатываю все до мелочей."])},
    "text-three": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Я владею навыками программирования такими как: HTML/CSS, Bootstrap, GSAP, Figma, JavaScript, React, Redux, GitHub и в настоящее время я заканчиваю изучать Node.JS, имею небольшой опыт работы в digital студии, где освоила Vue.js, Vuex, Nuxt, Quasar, Vuetify."])}
  },
  "project": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мои проекты"])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Смотреть проект"])}
  },
  "contact": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Связаться со мной"])},
    "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы можете мне позвонить по номеру"])},
    "messenger": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Посмотреть мой профиль в GitHub или связаться со мной через мессенджеры:"])}
  },
  "error": {
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Упс... Здесь ничего нет"])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вернуться на главную"])}
  }
}